// REST
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const ApiRepository = RepositoryFactory.get("api");

const getDefaultState = () => ({
  // DB 接続情報
  db: null,

  // アイコン画像 (ふきだし)
  iconUrl: null,

  // トーク画面
  linkTalkScreen: null,

  // 決済方法
  onlinePayment: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    db (state, val) { state.db = val; },
    iconUrl (state, val) { state.iconUrl = val; },
    linkTalkScreen (state, val) { state.linkTalkScreen = val; },
    onlinePayment (state, val) { state.onlinePayment = val; },
  },
  getters: {
    db: (state) => state.db,
    iconUrl: (state) => state.iconUrl,
    linkTalkScreen: (state) => state.linkTalkScreen,
    onlinePayment: (state) => state.onlinePayment,
  },
  actions: {
    async loadSettings (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const res = await ApiRepository.getSettings(shopId);
        // console.log(`[settings] loadSettings`, res);
        const settings = res.data.data;

        const payment = settings.onlinePayment;
        const paymentForLiff = {
          enabled: payment.enabled,
          defaultSelected: payment.defaultSelected,
          linepay: payment.linepay.enabled,
          paypay: payment.paypay.enabled,
          credit: payment.credit.enabled,
        };
        // console.log(`paymentForLiff`, paymentForLiff);

        this.commit("settings/db", settings.db, { root: true });
        this.commit("settings/linkTalkScreen", settings.bot.linkTalkScreen, { root: true });
        this.commit("settings/onlinePayment", paymentForLiff, { root: true });
        return settings;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  },
}
